<template>
  <section class="change-password">
    <ag-header
      title="Passwort ändern"
    />
    <form-wrapper
      v-show="!showSuccess"
      class="form--change-password"
      method="post"
      :action="`${apiUrl}/user-account/change-password`"
      enctype="application/json"
      :success-handler="passwordSet"
      @errorHandler="errorHandler"
      :pre-form-validation="checkPassword"
    >
      <form-row>
        <form-input
          name="currentPassword"
          type="password"
          label="Altes Passwort"
          :class="{ 'input--error-state' : hasErrorState('currentPassword') }"
          required
        />
      </form-row>

      <div
        class="change-password__reqs"
        :class="{ 'change-password__reqs--error' : hasErrorState('newPassword') }"
      >
        Das neue Passwort muss 8 - 32 Zeichen haben,
        Klein- und Großbuchstaben sowie min. eine Ziffer und ein Sonderzeichen (@$!%*?&) enthalten.
      </div>

      <form-row>
        <form-input
          name="newPassword"
          :class="{ 'input--error-state' : hasErrorState('newPassword') }"
          type="password"
          label="Neues Passwort"
          autocomplete="off"
          required
        />
      </form-row>

      <form-row
        class="form-row--bordered"
      >
        <form-input
          name="repeatNewPassword"
          :class="{ 'input--error-state' : hasErrorState('repeatNewPassword') }"
          type="password"
          label="Neues Passwort wiederholen"
          autocomplete="off"
          required
        />
      </form-row>

      <template v-slot:footer>
        <form-row>
          <form-button
            type="submit"
            class="button--change-password"
          >
            Passwort aktualisieren
          </form-button>
        </form-row>
      </template>
    </form-wrapper>
    <div
      v-show="showSuccess"
      class="change-password__success"
    >
      <div class="change-password__success-msg">
        <ag-icon
          modifier="success"
          name="success"
        />
        <p class="change-password__success-text">
          Ihr Passwort wurde aktualisiert.
        </p>
      </div>

      <router-link
        :to="{ name: 'dashboard.index' }"
        class="button button--change-password"
        tag="button"
      >
        Zur Startseite
      </router-link>
    </div>
  </section>
</template>

<script>
import AgHeader from '@/components/shared/AgHeader.vue';
import FormWrapper from '@/components/form/FormWrapper.vue';
import FormInput from '@/components/form/FormInput.vue';
import FormButton from '@/components/form/FormButton.vue';
import FormRow from '@/components/form/FormRow.vue';
import AgIcon from '@/components/shared/AgIcon.vue';

export default {
  name: 'change-password',
  props: {
    serviceData: {
      type: Array,
      default: null,
      required: false,
    },
    activeServices: {
      type: Array,
      default: null,
      required: false,
    },
    inactiveServices: {
      type: Array,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_ENDPOINT,
      showSuccess: false,
      failedInputNames: null,
    };
  },
  components: {
    AgHeader,
    FormWrapper,
    FormInput,
    FormButton,
    FormRow,
    AgIcon,
  },
  methods: {
    passwordSet() {
      this.showSuccess = true;
      this.failedInputNames = null;
    },
    errorHandler(failedInputNames) {
      this.failedInputNames = failedInputNames;
    },
    checkPassword(form) {
      this.failedInputNames = null;
      const currentPassword = form.querySelector('[name="currentPassword"]');
      const password1 = form.querySelector('[name="newPassword"]');
      const password2 = form.querySelector('[name="repeatNewPassword"]');
      if (password1.value === currentPassword.value) {
        password2.setCustomValidity('Das neue Passwort darf nicht identisch mit dem aktuellen Passwort sein.');
      } else if (password1.value !== password2.value) {
        password2.setCustomValidity('Die Passwörter stimmen nicht überein');
      } else {
        password2.setCustomValidity('');
      }
      return true;
    },
    hasErrorState(inputName) {
      return (
        this.failedInputNames
        && this.failedInputNames.includes(inputName)
      );
    },
  },
};
</script>

<style lang="scss">
.change-password {
  padding: rem(25px) rem(10px);
  max-width: rem(400px);
  margin: 0 auto;

  @include mq($mq-large) {
    padding: rem(30px);
    max-width: rem(1160px);
  }

  &__reqs {
    font-size: rem(13px);
    margin-bottom: rem(15px);
    line-height: 1.6;

    @include mq($mq-large) {
      font-size: rem(15px);
    }

    &--error {
      color: #D04040;
    }
  }

  &__success {
    text-align: center;
    margin-top: rem(80px);
    max-width: rem(400px);

    @include mq($mq-large) {
      margin-top: rem(55px);
      text-align: left;
    }
  }

  &__success-msg {
    margin-bottom: rem(60px);

    @include mq($mq-large) {
      display: flex;
      padding-bottom: rem(100px);
      margin-bottom: rem(30px);
      border-bottom: 1px solid #D5DCE5;
    }
  }

  &__success-text {
    font-family: $display-font;
    font-size: rem(24px);
    color: $primary-color;
    margin: 0;

    @include mq($mq-large) {
      display: inline-block;
      width: rem(320px);
      margin-left: rem(35px);
    }
  }

  label {
    font-size: rem(14px);
    font-weight: 600;
    color: $primary-color;
    margin-bottom: rem(5px);

    @include mq($mq-large) {
      font-size: rem(15px);
      font-weight: 400;
    }
  }
}
</style>
